<template>
  <div class="application-content">
    <order-view :id="id"></order-view>
  </div>
</template>

<script>
  import orderView from '@/components/User/Orders/OrderView'

  export default {
    name: "OrderView",
    props: ['id'],
    components: {
      orderView
    },
    data () {
      return {
        textBack: 'Back to orders',
        backUrl: '/orders/1'
      }
    }
  }
</script>